import React from 'react';

const TechnicalMaps = () => {
    return (
        <div>
            
        </div>
    );
};

export default TechnicalMaps;